import { Signal } from "@angular/core";
import { StoreBatchWeighing } from "../../storage/data-store/model/registrations/store-batch-weighing";
import { WeighingType } from "../../domain/model/weighing-type";
import { StoreBatch } from "../../storage/data-store/model/master-data/store-batch";
import { recordAsArray, recordGet } from "../record.function";


export function getBatchWeighingsForSection(sectionId: string, batchWeighings: StoreBatchWeighing[]): StoreBatchWeighing[] {
  const bwsForSection = batchWeighings.filter((batch) => {
    return batch.sectionId === sectionId;
  });

  if (!bwsForSection) {
    throw new Error(`Batch weighing with id ${sectionId} not found`);
  }
  return bwsForSection;
}

export function getBatchWeighingsForTrial(
  trialId: string,
  batchWeighings: Signal<Record<string, StoreBatchWeighing>>
): StoreBatchWeighing[] {
  const batchWeighingsArray = recordAsArray(batchWeighings());
  const bwsForTrial = batchWeighingsArray.filter((batch) => {
    return batch.trialId === trialId;
  });

  if (!bwsForTrial) {
    throw new Error(`Batch weighing with id ${trialId} not found`);
  }
  return bwsForTrial;
}

export function getBatchWeighingsAsArrayForSectionAndTrial(
  sectionId: string,
  trialId: string,
  batchWeighings: StoreBatchWeighing[]
): StoreBatchWeighing[] {
  const bwsForSectionAndTrial = batchWeighings.filter((batch) => {
    return batch.sectionId === sectionId && batch.trialId === trialId;
  });

  return bwsForSectionAndTrial;
}

export function getBatchWeighingsForSectionAndTrial(
  sectionId: string,
  trialId: string,
  batchWeighings: Signal<Record<string, StoreBatchWeighing>>
): StoreBatchWeighing[] {
  const batchWeighingsArray = recordAsArray(batchWeighings());
  const bwsForSectionAndTrial = batchWeighingsArray.filter((batch) => {
    return batch.sectionId === sectionId && batch.trialId === trialId;
  });
  return bwsForSectionAndTrial;
}

export function getBatchWeighingsWithType(type: WeighingType, batchWeighings: StoreBatchWeighing[]): StoreBatchWeighing[] {
  const matchingWeighings = batchWeighings.filter((batch) => {
    return batch.weighingType === type;
  });
  return matchingWeighings;
}

export function getSortedBatchWeighingsByBatchNumber(
  sectionId: string,
  trialId: string,
  batchWeighings: Signal<Record<string, StoreBatchWeighing>>,
  batches: Signal<Record<string, StoreBatch>>
): StoreBatchWeighing[] {
  const bwsForSectionAndTrial = getBatchWeighingsForSectionAndTrial(sectionId, trialId, batchWeighings);
  const sortedByBatchNumber = bwsForSectionAndTrial.sort(
    (a, b) => recordGet<StoreBatch>(batches(), a.batchId).number - recordGet<StoreBatch>(batches(), b.batchId).number
  );
  return sortedByBatchNumber;
}

export function getAdjacentBatchWeighingsByBatchNumber(
  sortedByBatcWeighings: StoreBatchWeighing[],
  batchWeighingId: string
): { previousBwId: string | undefined; nextBwId: string | undefined } {
  const adjacentBws = { previousBwId: undefined, nextBwId: undefined } as {
    previousBwId: string | undefined;
    nextBwId: string | undefined;
  };
  for (let i = 0; i < sortedByBatcWeighings.length; i++) {
    const bw = sortedByBatcWeighings[i];
    if (bw?.id === batchWeighingId) {
      adjacentBws.previousBwId = sortedByBatcWeighings[i - 1]?.id;
      adjacentBws.nextBwId = sortedByBatcWeighings[i + 1]?.id;
      break;
    }
  }
  return adjacentBws;
}
